import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MovieCardProps {
  item: MediaItem;
  showType?: boolean;
}

export default function MovieCard({ item, showType = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block w-full"
      title={`${item.title} - 在线观看与详情`}
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-100">
        <div className="relative aspect-[2/3] w-full">
          <img
            src={item.poster}
            alt={`${item.title} 海报`}
            title={`${item.title} 影视海报`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

          <div className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-white">
            <i className="ri-star-fill text-[11px]"></i>
            {item.rating.toFixed(1)}
          </div>

          {showType && (
            <div className="absolute right-2 top-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs text-background-50 backdrop-blur-sm">
              {item.type === "movie" ? "电影" : "剧集"}
            </div>
          )}

          <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-800">
              {item.status}
            </span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-white">
              <i className="ri-play-fill"></i>
            </span>
          </div>
        </div>
      </div>

      <h3 className="mt-2 truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600 md:text-base">
        {item.title}
      </h3>
      <p className="mt-0.5 truncate text-xs text-secondary-500">
        {item.year} · {item.region} · {item.genres.slice(0, 2).join("/")}
      </p>
    </Link>
  );
}